import React from 'react'
import { Modal } from 'react-bootstrap'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { useFormik } from 'formik'
import * as Yup from 'yup'

const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false,
}

const MIN_MSG_LEN = 2
const MAX_MSG_LEN = 700

export const TicketDetailsModal = ({
  openTicketDetailsModal,
  handleClose1,
  selectedTicket,
  onAddComment,
}) => {
  const commentSchema = Yup.object().shape({
    comment: Yup.string()
      .min(
        MIN_MSG_LEN,
        `Message must be at least ${MIN_MSG_LEN} charecters long`,
      )
      .max(
        MAX_MSG_LEN,
        `Message can't be longer than ${MAX_MSG_LEN} charecters long`,
      ),
  })

  const formik = useFormik({
    initialValues: {
      comment: '',
    },
    validationSchema: commentSchema,
    onSubmit: (values, { resetForm }) => {
      if (values.comment.trim()) {
        onAddComment({ ...values })
        resetForm()
      }
    },
  })

  return (
    <Modal
      show={openTicketDetailsModal}
      onHide={handleClose1}
      centered
      className="def_modal tcktdtl_modal"
    >
      <Modal.Header closeButton>
        <Modal.Title className="fn_s_18 color_blk f-w-700">
          Ticket Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form className="form def_form">
          <div className="px-10 apx-10 py-3 brdr_btm">
            <h6 className="fn_s_18 f-w-400 color_blk mb-0">
              Subject: {selectedTicket.subject}
            </h6>
            <p className="fn_s_14 f-w-400 color_blk opacity70 mb-0 ">
              {selectedTicket.message}
            </p>
          </div>
          <div className="px-10 apx-10 py-3 brdr_btm">
            <div className="row d-flex align-items-center">
              <div className="col-md-4">
                <label className="fn_s_14 mb-0">
                  {new Date(selectedTicket.createdAt).toLocaleString()}
                </label>
              </div>
              <div className="col-md-4 text-center">
                <label className="fn_s_14 mb-0">
                  Ticket No: {selectedTicket.ticketNo}
                </label>
              </div>
              <div className="col-md-4 text-right">
                <label className="fn_s_14 mb-0 mr-2">Status:</label>
                <select
                  className="sm_slct slctopen"
                  disabled
                  defaultValue={selectedTicket.status}
                >
                  <option value="OPEN">Open</option>
                  <option value="CLOSE">Closed</option>
                </select>
              </div>
            </div>
          </div>
          <div className="px-10 apx-10 py-3 brdr_btm">
            <div className="chat_box">
              <PerfectScrollbar
                className="scroll px-3"
                options={perfectScrollbarOptions}
                style={{ maxHeight: '350px', position: 'relative' }}
              >
                <div className="chat_txt">
                  {selectedTicket.comments &&
                    selectedTicket.comments.map((comment) => (
                      <div
                        key={comment._id}
                        className={`chat-clearfix ${
                          comment.senderId === selectedTicket.userId
                            ? 'float-right text-right'
                            : 'float-left text-left'
                        }`}
                      >
                        <div
                          className={
                            comment.senderId === selectedTicket.userId
                              ? 'chat_right'
                              : 'chat_left'
                          }
                        >
                          {comment.msg}
                        </div>
                        <label className="cht_lbl">
                          Sent {new Date(comment.createdAt).toLocaleString()}
                        </label>
                      </div>
                    ))}
                </div>
              </PerfectScrollbar>
            </div>
          </div>
          <div className="px-10 apx-10 py-3">
            <div className="sbmt_fm_btn">
              <form onSubmit={formik.handleSubmit}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter your message here"
                  {...formik.getFieldProps('comment')}
                />
                {formik.errors.comment && formik.touched.comment ? (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{formik.errors.comment}</div>
                  </div>
                ) : null}

                <button className="chtsbmt" type="submit">
                  Send Message
                  <span class="material-icons">send</span>
                </button>
              </form>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  )
}
